import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../context/LoaderContext';
import { useDebounce } from '../../../../hooks';
import { popup } from '../../../../utils';
import { MfgTable } from './MfgTable';
import { Button, Input, PopUpBox } from '../../../shared';
import { DropDown } from '../../../common';
import { getPrint } from '../../../../service/manufacturing';
import {
  BLP_COLUMNS,
  BUTTON,
  POPUP_TYPE,
  TEXT,
  DROPDOWN,
  EDIT_BOX_STATE,
} from '../../../../constants';

/**
 * BoxInfo - Box information form component
 * @param {Array} selectedPackage - Array of selected package IDs
 * @param {Function} setOpenPopUp - Function to control popup visibility
 * @param {Function} setBoxInfo - Function to set box information
 */
const BoxInfo = ({ selectedPackage, setOpenPopUp, setBoxInfo }) => {
  const [option, setOption] = useState(DROPDOWN.BOX_OPTION[0]);
  const boxInfo = {
    sizes: [DROPDOWN.BOX_OPTION[0]], // 12_4, 4_6
    package_types: ['single'], // single, mix
    package_ids: [...selectedPackage],
  };

  const handleBoxInfo = () => {
    setBoxInfo(boxInfo);
    setOpenPopUp(false);
  };

  return (
    <div className="p-3 ">
      <div className="d-flex flex-column gap-3  ms-4">
        <div className="d-flex justify-content-between ms-5 me-5">
          <label>{TEXT.BOX_SIZE}</label>
          <DropDown
            dropdownMenu={DROPDOWN.BOX_OPTION}
            value={option}
            setValue={setOption}
            printBox={true}
          />
        </div>
        <div className="d-flex justify-content-between ms-5 me-5">
          <label>{TEXT.BOX_TYPE}</label>
          <Input
            className="w-50 ps-2"
            type="text"
            disabled={true}
            value={boxInfo.package_types[0]}
          />
        </div>
        <div className="d-flex justify-content-center gap-3">
          <Button
            className="border-0 blue-btn d-flex align-items-center justify-content-center py-2 px-3"
            clickHandler={handleBoxInfo}
            text={BUTTON.SAVE}></Button>
          <Button
            className="border-0 blue-btn d-flex align-items-center justify-content-center py-2 px-3"
            clickHandler={() => setOpenPopUp(false)}
            text={BUTTON.CANCEL}></Button>
        </div>
      </div>
    </div>
  );
};

/**
 * BLPList - Box Label Package list component
 * @param {Array} data - Array of BLP data
 * @param {Function} setEditBoxState - Function to control edit box state
 * @param {Function} setReload - Function to trigger data reload
 */
export const BLPList = ({ data, setEditBoxState, setReload }) => {
  const { setLoading } = useLoader();
  const [openPopUp, setOpenPopUp] = useState(false);
  const [boxInfo, setBoxInfo] = useState({});
  const [printUrl, setPrintUrl] = useState('');

  const getPrintUrl = useDebounce(() => {
    popup(POPUP_TYPE.SUCCESS, 'Label Printing Initiated');
    getPrint({
      data: {
        sizes: [DROPDOWN.BOX_OPTION[0]], // 12_4, 4_6
        package_types: ['single'], // single, mix
        package_ids: [...data.map((pck) => pck.id)],
      },
    })
      .then((response) => {
        if (response.data.length > 0) {
          setLoading(false);
          setPrintUrl(response.data[0].split('?')[0]);
        } else {
          popup(POPUP_TYPE.ERR, response?.message);
          setLoading(false);
        }
      })
      .catch((err) => popup(POPUP_TYPE.ERR, err.message));
  }, 1000);

  useEffect(() => {
    if (Object.keys(boxInfo).length) {
      setLoading(true);
      getPrintUrl();
    }
  }, [boxInfo, getPrintUrl]);

  useEffect(() => {
    if (printUrl) {
      window.open(printUrl, '_blank', 'noreferrer');
      setEditBoxState(EDIT_BOX_STATE.CLOSED);
      setReload?.(true);
    }
  }, [printUrl, setEditBoxState, setReload]);

  return data.length > 0 ? (
    <div className="edit-container p-4">
      <h5 className="text-center mb-4 mt-0">{BUTTON.GENERATE_BLP}</h5>
      <div className="w-100 table-3">
        <MfgTable column={BLP_COLUMNS} data={data} clickHandler={() => { }} />
      </div>
      {openPopUp && (
        <PopUpBox openPopUpBox={openPopUp}>
          <BoxInfo
            selectedPackage={data.map((pck) => pck.id)}
            setOpenPopUp={setOpenPopUp}
            setBoxInfo={setBoxInfo}
          />
        </PopUpBox>
      )}
      <div className="d-flex align-items-center justify-content-center gap-4 w-100 mt-4">
        <Button
          clickHandler={getPrintUrl}
          className="border-0 blue-btn d-flex align-items-center justify-content-center py-2 px-3">
          {BUTTON.PRINT_LABEL}
        </Button>
        <Button
          clickHandler={() => {
            setEditBoxState(EDIT_BOX_STATE.CLOSED);
            setReload?.(true);
          }}
          className="border-0 blue-btn d-flex align-items-center justify-content-center py-2 px-3">
          {BUTTON.CLOSE}
        </Button>
      </div>
    </div>
  ) : null;
};
